<template>
  <module-section :title="data.name">
    <div class="container">
      <div class="item" v-for="(article, j) in data.contents" :key="j" :style="{ 'max-width': maxWidth }">
        <div class="title">{{ article.name }}</div>
        <div class="img"><img :src="article.img" /></div>
        <div class="intro">{{ article.intro }}</div>
        <div class="btn" @click="handleToArticle">{{ article.name }} >>></div>
      </div>
    </div>
  </module-section>
</template>

<script>
import ModuleSection from './ModuleSection.vue'

export default {
  components: {
    ModuleSection
  },
  props: {
    data: {
      type: Object,
      require: true
    },
    maxWidth: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleToArticle(menu1Id, menu2Id) {
      this.$router.push({
        path: `/article/index?menu1Id=${ menu1Id }&menu2Id=${ menu2Id }`
      })
      // this.$message.success({
      //   message: 'Upgrading。。。',
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
}

.item {
  margin-right: 30px;
  flex: 1;
  padding: 30px;
  font-size: 18px;
  text-align: center;
  background-color: rgb(217, 217, 217);

  &:last-child {
    margin-right: 0;
  }

  .title {
    font-weight: 700;
    margin-bottom: 12px;
    font-size: 1.25em;
    text-align: center;
  }

  .img {
    img {
      margin: 0 auto 24px;
      width: 100%;
    }
  }

  .intro {
    height: 120px;
    font-size: .512em;
  }

  .btn {
    margin-bottom: 10px;
    text-align: left;
    font-weight: 700;
    font-size: 16px;
    color: #b1040e;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
